import React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import { ErrorMessage } from "formik";
import { DescriptionInputProps } from "./description-input-props";
import "./description-input-component.scss";

const DescriptionInputComponent: React.FC<DescriptionInputProps> = ({
  fieldName,
  placeholder = "Add Description",
  optional = false,
  disabled,
  value,
  onChange,
  minlength,
  maxlength,
  isRequired = false,
  rows = 6,
  readOnly = false,
  renderErrorMessage = true,
  minRows = 1,
}) => {
  return (
    <Box>
      <div className={`description-input-component ${isRequired ? "required" : ""}`}>
        <FormControl>
          <TextField
            name={fieldName}
            placeholder={placeholder}
            required={optional}
            disabled={disabled}
            id={fieldName}
            value={value}
            onChange={onChange}
            multiline
            minRows={minRows || 1}
            maxRows={rows}
            variant="outlined" // Using 'outlined' to ensure SCSS styles apply
            InputLabelProps={{ shrink: true }} // Forces label to stay above
            inputProps={{
              minLength: minlength,
              maxLength: maxlength,
              readOnly: readOnly,
            }}
            sx={{ textarea: { minHeight: "auto", height: "auto" } }}
          />
        </FormControl>
        {renderErrorMessage && <ErrorMessage
          name={fieldName ?? ""}
          component="div"
          className="error-message"
        />}
      </div>
    </Box>
  );
};

export default DescriptionInputComponent;
